export const game: GameSetup = {
    foodTypes: [
        'burgers',
        'donuts',
        'lemonade',
        'pizza',
        'sushi',
        'tacos',
    ],
    history: {
        expiration: 1000 * 60 * 60 * 24,
    },
    hurricane: {
        bands: {
            red: 0.05,
            orange: 0.1,
            yellow: 0.175,
            green: 0.3,
        },
        trials: 100,
    },
    outlier: {
        day: 41,
        multiplier: 1.4,
        percentile: 0.9,
    },
    prediction: {
        default: 50000,
        min: 15000,
        max: 75000,
    },
    retention: {
        days: 8,
        decimals: 0,
        multiplier: 100,
        slope: 0.3,
        value: 0.8,
    },
    standardDeviation: {
        default: 0.15,
        denominator: 3.29,
        week28: 0.05,
    },
    steps: [
        {
            constraint: {
                max: 100000,
                min: 5000,
            },
            conversion: {
                decimals: 1,
                initialMax: 0.5,
                initialMin: 0.01,
                max: 0.5,
                min: 0.01,
                multiplier: 100,
                operator: '%',
            },
            name: 'People Walking By In A Day',
            operator: 'people',
        },
        {
            constraint: {
                max: 10000,
                min: 200,
            },
            conversion: {
                decimals: 1,
                initialMax: 0.8,
                initialMin: 0.1,
                max: 0.8,
                min: 0.1,
                multiplier: 100,
                operator: '%',
            },
            name: 'Hungry People',
            operator: 'people',
        },
        {
            constraint: {
                max: 2000,
                min: 80,
            },
            conversion: {
                decimals: 1,
                initialMax: 0.8,
                initialMin: 0.1,
                max: 0.8,
                min: 0.5,
                multiplier: 100,
                operator: '%',
            },
            name: 'People Looking At The Menu',
            operator: 'people',
        },
        {
            constraint: {
                max: 1000,
                min: 40,
            },
            conversion: {
                decimals: 2,
                initialMax: 50,
                initialMin: 5,
                max: 50,
                min: 5,
                multiplier: 1,
                operator: '$',
            },
            name: 'People Placing Orders',
            operator: 'people',
        },
        {
            constraint: {
                max: Infinity,
                min: 0,
            },
            conversion: {
                decimals: 0,
                initialMax: 0,
                initialMin: 0,
                max: 0,
                min: 0,
                multiplier: 0,
                operator: '',
            },
            deviation: {
                min: 0.5,
                max: 0.9,
            },
            name: 'Revenue Per Day',
            operator: 'dollars',
        },
    ],
    truckNames: [
        'Relish Life',
        'Grub \'N Go',
        'Bite-Sized Beats',
        'Lettuce Eat',
        'Bun Voyage',
        'Rolling Relish',
        'Chew Chew Train',
        'Bite the Road',
        'Feast Beast',
        'Snack Shack Attack',
        'Nosh Nomad',
        'Eats on Streets',
        'Ketchup if You Can',
    ],
};